import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('my-bar',{on:{"toggleDrawer":function($event){return _vm.toggleDrawer()}}}),_c('drawer',{ref:"drawer"}),_c('cookie'),_c(VMain,[_c('router-view')],1),_c('my-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }